import React from 'react';
import loginStyles from './login.module.css'
import LoginWrapper from "./loginWrapper";
import {useDispatch} from "react-redux";
import {LOGIN_STEP} from "../../helper/constants";
import {sendPasswordResetAPI} from "../../api/authAPI";
import {setLoginStatus} from "../../store/loginSlice";

const ForgotPassword = () => {

    const dispatch = useDispatch()

    const [email, setEmail] = React.useState("");

    const reset = () => {
        if (email === "") {
            return false;
        }

        sendPasswordResetAPI(email).then(r => {
            if (r) {
                window.alert("If the email provided matches an email on file, a reset link has been sent.")
                dispatch(setLoginStatus(LOGIN_STEP.NEW_LOGIN))
            }
        })

        return false;
    }

    const returnToSignIn = () => {
        dispatch(setLoginStatus(LOGIN_STEP.NEW_LOGIN))
    }

    return (
        <LoginWrapper>
            <form action="" className={loginStyles.form}>
                <p className={loginStyles.errorText}>
                    Forgot password form is currently disabled. Please reach out to the helpdesk for assistance in
                    resetting your password.
                </p>
                <label className={loginStyles.fieldLabel} id="emailLabel" htmlFor="email">Recovery Email:</label>
                <input disabled={true} onChange={e => setEmail(e.currentTarget.value)} name={"email"}
                       id={"email"} className={loginStyles.textField} type={"text"} value={email}/>
                <button style={{paddingLeft: 0}} className={loginStyles.forgotPasswordButton} type={"button"}
                        onClick={returnToSignIn}>Return to Sign In
                </button>
                <button disabled={true} style={{marginTop: 50}} onClick={reset} type={"button"}
                        className={loginStyles.button}>Reset
                </button>
            </form>
        </LoginWrapper>
    );
};

export default ForgotPassword;